import EditBillingAddressDialog from "@/pages/(app)/returns/view/components/edit-billing-address/edit-billing-address-dialog";
import type { ReturnRequestDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { HouseIcon } from "lucide-react";

type BillingAddressProps = {
  returnRequest: ReturnRequestDto;
};

export default function BillingAddress({ returnRequest }: BillingAddressProps) {
  const t = useTranslation();
  const { billingAddress } = returnRequest;

  const name = billingAddress.first_name + "  " + billingAddress.last_name;

  return (
    <div className="group">
      <div className={"flex flex-row items-center justify-between"}>
        <h2 className="text-sm font-medium text-gray-500 inline-flex items-center gap-2">
          <HouseIcon className="size-3" />
          {t("misc.billingAddress")}
        </h2>
        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <EditBillingAddressDialog
            returnRequest={returnRequest}
            key={returnRequest.id}
          />
        </div>
      </div>
      <div className={"flex flex-col gap-1 text-gray-900 font-regular text-sm"}>
        <span className={"font-medium"}>{name}</span>
        <span>{billingAddress.address1}</span>
        <span>{billingAddress.address2}</span>
        <span>{billingAddress.zip + " " + billingAddress.city}</span>
        <span>{billingAddress.country}</span>
      </div>
    </div>
  );
}
